







































































import { Component } from 'vue-property-decorator';
import { NotificationHelper as _notification } from '@/helper/notifications.helper';
import { Base } from '@/components/common/base';
import { Utils } from '@/helper/utils';
import { paymentService } from '@/shared';
import { IPaymentDialog } from '@/models/paymentDialog';

@Component({
  components: {
    CenposPayment: () => import('@/components/common/cenpos.payment.vue'),
    SquarePayment: () => import('@/components/common/square.payment.vue'),
    CloverPayment: () => import('@/components/common/clover.payment.vue'),
    PaymentDialog: () => import('@/components/common/payment.dialog.vue')
  }
})
export default class AdHocPaymentPage extends Base {
  public paymentDialog: boolean = false;
  public transactionHeaderId: string = '';
  public detailId: string = '';
  public loading: boolean = false;
  public requestProgress: boolean = false;
  public adhocDetails: any = {};

  public cenposDialog: boolean = false;
  public squareDialog: boolean = false;
  public isCloverDialog: boolean = false;

  public cenposStatus: boolean = false;
  public currentUrl: string = '';
  public storeName: string = '';
  public email: string = '';
  public zipCode: string = '';
  public city: string = '';
  public state: string = '';
  public address: string = '';
  public customerCode: string = '';
  public accountNumber: string = '';
  public controlNumber: string = '';
  public referenceNumber: string = '';
  public adhocLineItem: string = '';
  public isPaymentPending: boolean = false;


  public provider: string = '';
  public adhocId: string = '';
  public storeId: number = 0;
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public loggedInUserEmail: string = '';
  public loggedInUserId: string = '';

  public amountToBePaid: string = '';
  public amountWithServiceCharges: string = '';
  public isOverriedCCFeeApplied: boolean = false;
  public bypassReason: string = '';
  public isCenposConfigured: boolean = false;
  public isSquareConfigured: boolean = false;
  public isCloverConfigured: boolean = false;

  public mounted(): void {
    this.$watch(
      "adhocDetails",
      (newVal) => {
        this.paymentOptions.amount = Number(newVal.amount);
        this.paymentOptions.name = newVal.name;
        this.paymentOptions.account = newVal.accountNumber;
        this.paymentOptions.control = newVal.controlNumber;
        this.paymentOptions.reference = newVal.referenceNumber;
      },
      {
        deep: true,
      }
    );

    this.$watch("adhocLineItem", (newVal) => {
      this.paymentOptions.lineItems = newVal;
    });

    this.$watch("amountWithServiceCharges", (newVal) => {
      this.paymentOptions.amountWithServiceCharges = newVal;
    });

    this.$watch("transactionHeaderId", (newVal) => {
      this.paymentOptions.transactionHeaderId = newVal;
    });

    this.$watch("detailId", (newVal) => {
      this.paymentOptions.lastPaymentDetailId = newVal;
    });

    this.$watch("customerCode", (newVal) => {
      this.paymentOptions.customerKey = newVal;
    });

    this.$watch("address", (newVal) => {
      this.paymentOptions.address = newVal;
    });

    this.$watch("city", (newVal) => {
      this.paymentOptions.city = newVal;
    });

    this.$watch("state", (newVal) => {
      this.paymentOptions.state = newVal;
    });

    this.$watch("zipCode", (newVal) => {
      this.paymentOptions.zipcode = newVal;
    });

    this.$watch("email", (newVal) => {
      this.paymentOptions.customerEmail = newVal;
    });

    this.$watch("bypassReason", (newVal) => {
      this.paymentOptions.bypassReason = newVal;
    });

    this.$watch("isOverriedCCFeeApplied", (newVal) => {
      this.paymentOptions.isOverrideCCFeeApplied = newVal;
    });

    this.$watch("storeId", (newVal) => {
      this.paymentOptions.storeId = newVal;
    });
    this.$watch("tenantId", (newVal) => {
      this.paymentOptions.tenantId = newVal;
    });
    this.$watch("enterpriseId", (newVal) => {
      this.paymentOptions.enterpriseId = newVal;
    });
    this.transactionHeaderId = this.$route.params.txid;
    this.detailId = this.$route.params.detailid;
    this.currentUrl = window.location.href;
    if (this.transactionHeaderId && this.detailId) {
      this.adhocDetail(this.transactionHeaderId, this.detailId);
    } else {
      this.showAlert(
        false,
        this.$t('depositLogPayment.alertTransactionIdEmpty')
      );
    }

  }

  public async adhocDetail(
    transactionHeaderId: string,
    txDetailId: string
  ): Promise<void> {
    try {
      this.loading = true;
      const adhocDetail = await paymentService.getAdhocDetail(
        transactionHeaderId,
        txDetailId
      );
      this.adhocDetails = adhocDetail;

      this.tenantId = adhocDetail.tenantId;
      this.enterpriseId = adhocDetail.enterpriseId;
      this.storeName = adhocDetail.storeName;
      this.adhocId = adhocDetail.id;
      this.storeId = adhocDetail.storeId;
      this.loggedInUserEmail = this.userSession.email;
      this.loggedInUserId = this.userSession.sessionUserId;
      this.amountToBePaid = adhocDetail.amount;
      this.amountWithServiceCharges = adhocDetail.amountWithServiceCharges;
      this.email = adhocDetail.email;
      this.isPaymentPending = adhocDetail.isPending;
      this.adhocDetails.control = adhocDetail.contactNumber;
      this.adhocDetails.account = adhocDetail.accountNumber;
      this.adhocDetails.referenceNumber = adhocDetail.referenceNumber;
      this.isOverriedCCFeeApplied = adhocDetail.isOverrideCCFeeApplied;
      this.bypassReason = adhocDetail.byPassReason;

      const adhocLine = JSON.stringify(adhocDetail.lineItems);
      this.adhocLineItem = adhocLine;

      this.provider = adhocDetail.provider;
      this.isCenposConfigured = adhocDetail.isCenposConfigured;
      this.isSquareConfigured = adhocDetail.isSquareConfigured;
      this.isCloverConfigured = adhocDetail.isCloverConfigured;

      if (this.adhocDetails.status == 'Success') {
        this.showAlert(true, this.$t('depositLogPayment.alertPaymentApproved'));
      } else if (this.adhocDetails.paymentDetailStatus === 'InProcess') {
        this.showAlert(true, this.$t('Payment is in process, Please check the final status in Payment report.'));
      }

    } finally {
      this.loading = false;
    }
  }

  public async pay(): Promise<void> {
    try {
      if (this.provider == 'Vantiv') {
        this.requestProgress = true;

        const depositLog = await paymentService.adhocPay(
          this.transactionHeaderId,
          this.detailId
        );
        window.location.href = depositLog.paymentUrl;
      } else {
        this.paymentDialog = true;
        this.$root.$emit('validatePaymentProvider');
      }
    } finally {
      this.requestProgress = false;
    }
  }

  public updateCloverDialog(cloverDialogVaue) {
    this.isCloverDialog = cloverDialogVaue;
  }

  public updateCenposDialog(cenposDialogVaue) {
    this.cenposDialog = cenposDialogVaue;
  }

  public updateSquareDialog(squareDialogValue) {
    this.squareDialog = squareDialogValue;
  }

  public validateCenpos(): string {
    let message = '';
    if (this.city == undefined || this.city == '') {
      message += ' City';
    }

    if (this.state == undefined || this.state == '') {
      message += ' State';
    }

    if (this.address == undefined && this.address == '') {
      message += ' Address';
    }

    return message;
  }

  public paymentOptions: IPaymentDialog = {
    id: "AdhocPaymentAnonymous",
    url: window.location.href,
    amount: Number(this.adhocDetails.amount),
    recordIdentifier: "AdHoc",
    type: "0",
    transactionHeaderId: this.transactionHeaderId,
    lastPaymentDetailId: this.detailId,
    customerKey: this.customerCode,
    address: this.address,
    city: this.city,
    state: this.state,
    zipcode: this.zipCode,
    customerEmail: this.email,
    name: this.adhocDetails.name,
    account: this.adhocDetails.accountNumber,
    control: this.adhocDetails.controlNumber,
    reference: this.adhocDetails.referenceNumber,
    lineItems: this.adhocLineItem,
    amountWithServiceCharges: this.amountWithServiceCharges,
    showTextField: true,
    bypassReason: this.bypassReason,
    isOverrideCCFeeApplied: this.isOverriedCCFeeApplied,
    storeId: this.storeId,
    tenantId: this.tenantId,
    enterpriseId: this.enterpriseId
  };
  public updatePaymentDialog(paymentDialogValue) {
    this.paymentDialog = paymentDialogValue;
  }
}
